<section class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
      <div class="title-block">
        <p class="eyebrow">Invoices</p>
        <h1>Track and finish invoices faster</h1>
        <p class="subtitle">Filter by type and track active, paid, reconciled, and refunded invoices.</p>
      </div>
    </div>
    <div class="right mobile-hide">
      <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu1"><mat-icon>receipt_long</mat-icon> New RCTI Invoice</button>
      <mat-menu #menu1="matMenu">
        <button (click)="createInvoice('rcti-ewaste')" mat-menu-item>Ewaste Commodity Purchase</button>
        <button (click)="createInvoice('rcti-repairlab')" mat-menu-item>Repair Lab Commodity Purchase</button>
      </mat-menu>
      <button mat-raised-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>note_add</mat-icon> New Invoice</button>
      <mat-menu #menu="matMenu">
        <button (click)="createInvoice('repair')" mat-menu-item>Repair Lab</button>
        <button (click)="createInvoice('ebay')" mat-menu-item>EBAY</button>
        <button (click)="createInvoice('ebay-new-design')" mat-menu-item>EBAY - New Design</button>
      </mat-menu>
    </div>
  </header>

  <div class="controls">
    <div class="status-cards">
      <button type="button" class="status-card focus" [class.active]="activeTab=='active'" (click)="activateTab('active')">
        <p class="label">Active</p>
        <div class="value">{{activeCount}}</div>
        <p class="hint">Open invoices</p>
      </button>
      <button type="button" class="status-card success" [class.active]="activeTab=='paid'" (click)="activateTab('paid')">
        <p class="label">Paid</p>
        <div class="value">{{completedCount}}</div>
        <p class="hint">Awaiting reconciliation</p>
      </button>
      <button type="button" class="status-card success" [class.active]="activeTab=='reconciled'" (click)="activateTab('reconciled')">
        <p class="label">Reconciled</p>
        <div class="value">{{reconciledCount}}</div>
        <p class="hint">Matched invoices</p>
      </button>
      <button type="button" class="status-card info" [class.active]="activeTab=='refunds'" (click)="activateTab('refunds')">
        <p class="label">Refunds</p>
        <div class="value">{{refundsCount}}</div>
        <p class="hint">Refunded invoices</p>
      </button>
      <button type="button" class="status-card info" [class.active]="activeTab=='payments'" (click)="activateTab('payments')">
        <p class="label">Payments</p>
        <div class="value">{{paymentsCount}}</div>
        <p class="hint">Recorded payments</p>
      </button>
    </div>

    <div class="date-range" *ngIf="dateRange">
      <div class="date-nav" *ngIf="dateMode != DateMode.Custom && dateMode != DateMode.AllTime">
        <button mat-button (click)="previousDateRange()" [disabled]="isLoading">{{getLabel()[0]}}</button>
        <button mat-button *ngIf="dateOffset > 0" (click)="nextDateRange()" [disabled]="isLoading">{{getLabel()[1]}}</button>
      </div>
      <div class="date-picker">
        <button mat-stroked-button [matMenuTriggerFor]="dateMenu">{{dateRange.start | date}} to {{dateRange.end | date}}</button>
        <mat-menu #dateMenu="matMenu">
          <button (click)="switchToWeekly()" mat-menu-item>Weekly</button>
          <button (click)="switchToMonthly()" mat-menu-item>Monthly</button>
          <button (click)="switchToQuaterly()" mat-menu-item>Quaterly</button>
          <button (click)="switchToYearly()" mat-menu-item>Yearly</button>
          <button (click)="switchToAllTime()" mat-menu-item>All Time</button>
        </mat-menu>
      </div>
    </div>

    <div class="meta">
      <button mat-stroked-button routerLink="/invoices/memory-import"><mat-icon>auto_awesome</mat-icon> Invoice memories</button>
      <button *ngIf="activeTab === 'payments'" mat-stroked-button routerLink="/invoices/payment-linker-once">
        <mat-icon>link</mat-icon> Bulk link certain
      </button>
      <button mat-stroked-button [matMenuTriggerFor]="filterMenu"><mat-icon>filter_list</mat-icon> Filter</button>
      <mat-menu #filterMenu="matMenu">
        <button mat-menu-item (click)="filter(null); filterPaymentMethod(null)">All invoices</button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="filter('standard')">PC Clinic</button>
        <button mat-menu-item (click)="filter('repair')">Repair Lab</button>
        <button mat-menu-item (click)="filter('rcti-repairlab')">Repair Lab Commodity Purchase</button>
        <button mat-menu-item (click)="filter('ewaste')">E-Waste</button>
        <button mat-menu-item (click)="filter('rcti-ewaste')">E-Waste Commodity Purchase</button>
        <button mat-menu-item (click)="filter('hisense')">Hisense</button>
        <button mat-menu-item (click)="filter('ebay')">Ebay</button>
        <button mat-menu-item (click)="filter('ebay-new-design')">Ebay - New Design</button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="filterPaymentMethod('cash')">Paid by cash</button>
        <button mat-menu-item (click)="filterPaymentMethod('ebay')">Paid by Ebay</button>
        <button mat-menu-item (click)="filterPaymentMethod(null)">Any payment method</button>
      </mat-menu>
    </div>
  </div>

  <div class="filter-indicator" *ngIf="activeFilters.length">
    <div class="label">Filters</div>
    <div class="chips">
      <span class="chip" *ngFor="let f of activeFilters">{{f}}</span>
    </div>
    <button mat-stroked-button color="primary" (click)="clearFilters()"><mat-icon>close</mat-icon> Clear</button>
  </div>

  <mat-spinner *ngIf="isLoading && !hasDataForCurrentTab"></mat-spinner>

  <div class="table-card" *ngIf="activeTab === 'active' && dataSourceActive">
    <table class="invoices" mat-table [dataSource]="dataSourceActive">
      <ng-container matColumnDef="status">
        <td class="status-column" mat-cell *matCellDef="let element">
          <div class="status" [ngClass]="getInvoiceStatus(element)">{{getInvoiceStatus(element)}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <td class="date-column" mat-cell *matCellDef="let element"> {{element.dateCreated | date:'dd-MM-yy'}} </td>
      </ng-container>

      <ng-container matColumnDef="number">
        <td class="number-column" mat-cell *matCellDef="let element"> {{element.number}} </td>
      </ng-container>

      <ng-container matColumnDef="custom">
        <td class="custom-column" mat-cell *matCellDef="let element"> {{element.custom}} </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <td mat-cell *matCellDef="let element"> {{getCustomer(element)}} </td>
      </ng-container>

      <ng-container matColumnDef="amountTotal">
        <td class="amount-total-column" mat-cell *matCellDef="let element"> {{element['total'] | human}} </td>
      </ng-container>

      <ng-container matColumnDef="paymentMethod">
        <td class="amount-due" mat-cell *matCellDef="let element"> {{element['paymentsMade'][0]?.method}} </td>
      </ng-container>

      <ng-container matColumnDef="print">
        <td class="print" mat-cell *matCellDef="let element">
          <div (click)="print(element, $event)">Print</div>
        </td>
      </ng-container>

      <tr (click)="editInvoice(element.number)" class="invoice-row" mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
    </table>
    <div class="load-more" *ngIf="dataSourceActive?.data?.length < activeCount">
      <button mat-stroked-button (click)="loadMore('active')"><mat-icon>expand_more</mat-icon> Load more</button>
      <div class="hint">{{dataSourceActive?.data?.length}} / {{activeCount}} shown</div>
    </div>
  </div>

  <div class="table-card" *ngIf="(activeTab === 'paid' || activeTab === 'reconciled' || activeTab === 'refunds') && completedTabDataSource">
    <table class="invoices" mat-table [dataSource]="completedTabDataSource">
      <ng-container matColumnDef="status">
        <td class="status-column" mat-cell *matCellDef="let element">
          <div class="status" [ngClass]="getInvoiceStatus(element)">{{getInvoiceStatus(element)}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <td class="date-column" mat-cell *matCellDef="let element"> {{element.dateCreated | date:'dd-MM-yy'}} </td>
      </ng-container>

      <ng-container matColumnDef="number">
        <td class="number-column" mat-cell *matCellDef="let element"> {{element.number}} </td>
      </ng-container>

      <ng-container matColumnDef="custom">
        <td class="custom-column" mat-cell *matCellDef="let element"> {{element.custom}} </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <td mat-cell *matCellDef="let element"> {{getCustomer(element)}} </td>
      </ng-container>

      <ng-container matColumnDef="amountTotal">
        <td class="amount-total-column" mat-cell *matCellDef="let element"> {{element['total'] | human}} </td>
      </ng-container>

      <ng-container matColumnDef="paymentMethod">
        <td class="amount-due" mat-cell *matCellDef="let element"> {{element['paymentsMade'][0]?.method}} </td>
      </ng-container>

      <ng-container matColumnDef="print">
        <td class="print" mat-cell *matCellDef="let element"><div (click)="print(element, $event)">Print</div></td>
      </ng-container>

      <tr (click)="editInvoice(element.number)" class="invoice-row" mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
    </table>
    <div class="load-more" *ngIf="completedTabDataSource?.data?.length < completedTabCount">
      <button mat-stroked-button (click)="loadMore(activeTab === 'refunds' ? 'refunds' : activeTab === 'reconciled' ? 'reconciled' : 'paid')"><mat-icon>expand_more</mat-icon> Load more</button>
      <div class="hint">{{completedTabDataSource?.data?.length}} / {{completedTabCount}} shown</div>
    </div>
  </div>

  <div class="table-card" *ngIf="activeTab === 'payments' && dataSourcePayments">
    <table class="invoices" mat-table [dataSource]="dataSourcePayments">
      <ng-container matColumnDef="date">
        <td class="date-column" mat-cell *matCellDef="let element"> {{element.payment?.date | date:'dd-MM-yy'}} </td>
      </ng-container>

      <ng-container matColumnDef="invoiceNumber">
        <td class="number-column" mat-cell *matCellDef="let element">
          #{{element.invoiceNumber}}
          <span class="invoice-type" *ngIf="element.invoiceType">· {{element.invoiceType}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <td mat-cell *matCellDef="let element"> {{getCustomer(element)}} </td>
      </ng-container>

      <ng-container matColumnDef="paymentMethod">
        <td class="amount-due" mat-cell *matCellDef="let element"> {{element.payment?.method}} </td>
      </ng-container>

      <ng-container matColumnDef="note">
        <td class="custom-column" mat-cell *matCellDef="let element"> {{element.payment?.note || '—'}} </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <td class="amount-total-column" mat-cell *matCellDef="let element"> {{element.payment?.amount | human}} </td>
      </ng-container>

      <tr (click)="openPayment(element)" class="invoice-row" mat-row *matRowDef="let element; columns: paymentColumnsToDisplay;"></tr>
    </table>
    <div class="load-more" *ngIf="dataSourcePayments?.data?.length < paymentsCount">
      <button mat-stroked-button (click)="loadMore('payments')"><mat-icon>expand_more</mat-icon> Load more</button>
      <div class="hint">{{dataSourcePayments?.data?.length}} / {{paymentsCount}} shown</div>
    </div>
  </div>
</section>
